import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledVoiceLibraryHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid ${COLOR.borderDropdown};
`;
